// DPH (Diesel Price Hike) computation — mirrors §8 of the pricing-upload brief.
// Pure: given the agreement's DPH config, the month's diesel price D1, and a
// sample forward freight, returns the DPH applied to one shipment.
//
//   - Variance is ALWAYS measured from Base (never from Trigger).
//   - Trigger (if enabled) only controls WHEN the mechanism switches on.
//   - Percentage-Linked → % of the selected charges.
//   - Rupee-Linked      → flat ₹ per shipment.
export function computeDph(dph, d1, freight = 0) {
  const base = Number(dph?.base_price) || 0;
  const rate = Number(dph?.hike_rate) || 0;
  const D1 = Number(d1) || 0;
  const out = { active: false, dphPct: 0, dphAmount: 0, reason: '' };

  if (!dph?.enabled) { out.reason = 'DPH not enabled'; return out; }

  // Trigger gate.
  if (dph.trigger_enabled && dph.trigger_price != null && dph.trigger_price !== '') {
    if (D1 < Number(dph.trigger_price)) { out.reason = `D₁ ₹${D1} < trigger ₹${dph.trigger_price} → DPH 0`; return out; }
  } else if (D1 <= base) {
    out.reason = `D₁ ₹${D1} ≤ base ₹${base} → DPH 0`; return out;
  }

  out.active = true;
  if (dph.mechanism === 'rupee') {
    out.dphAmount = +((D1 - base) * rate).toFixed(2);
    out.reason = `(${D1} − ${base}) × ${rate} = ₹${out.dphAmount} flat`;
  } else {
    const variancePct = ((D1 - base) / base) * 100;
    out.dphPct = +(variancePct * rate).toFixed(2);
    out.dphAmount = +((Number(freight) || 0) * out.dphPct / 100).toFixed(2);
    out.reason = `variance ${variancePct.toFixed(2)}% × ${rate} = ${out.dphPct}% → ₹${out.dphAmount} on ₹${freight}`;
  }
  return out;
}
